import React from 'react';

import {convertParamsForVersionsQuery} from 'app/components/general/DetailPage/LeftSidebar/VersionsSidebar/utils';
import {VersionsSidebarFactory} from 'app/components/general/VersionsSidebar';
import {InfiniteListRTK} from 'app/general/datafetchers/InfiniteListRTK';
import {useProcessVersions} from 'app/process/api';

import type {LeftSidebarPanelType} from 'app/components/general/DetailPage/LeftSidebar/structure/types';
import type {
  ProcessHashidSerializedType,
  ProcessVersionSerializedType,
} from 'sweet-types';

const VersionsSidebarComponent =
  VersionsSidebarFactory<ProcessVersionSerializedType>();
export function ProcessVersionsPanelContent({
  object,
  version,
}: LeftSidebarPanelType<ProcessHashidSerializedType>) {
  return (
    <InfiniteListRTK
      fetchParams={{objectId: object.id}} // It's OK to pass a new object here, because
      // we are relying on ``fetchParams`` stringification in useInfiniteListFetcherRTK
      useDataHook={useProcessVersions}
      paramsConverter={convertParamsForVersionsQuery}
    >
      {({results: versions, refetch, loadNext, hasNext}) => (
        <VersionsSidebarComponent
          object={object}
          selectedVersion={version}
          loadVersions={async () => refetch()}
          loadMoreVersions={async () => loadNext()}
          moreToLoad={hasNext}
          versions={versions}
        />
      )}
    </InfiniteListRTK>
  );
}
